// Model.js
// -----------------------
// @module Case
define("nowakdental.ADAComplaince.ADAComplaince.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/ADAComplaince/SuiteScript2/ADAComplaince.Service.ss"
            ),
            true
        )
});
});
